<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ConfirmationRedirectMixin extends Vue {
        async redirectAfterPayment(orderId) {
            await this.orderDetailsRedirect(orderId)
        }

        async orderDetailsRedirect(orderId) {
            if (this.isDriver || this.isGuide) {
                await this.$router.push({name: 'scheduler', params: {id: orderId}})
            } else {
                await this.$router.push({name: 'order-details', params: {id: orderId}})
            }
        }

        get isGuide() {
            return authStore.isGuide
        }

        get isDriver() {
            return authStore.isDriver
        }
    }

    export default ConfirmationRedirectMixin
</script>
